/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const ForwardLargeIcon = ({ width = 24, height = 28, color = '#fff', children, ...props }: IIconProps) => (
  <svg width={width} height={height} viewBox='0 0 24 28' fill={color} {...props} xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M19.6463 0.979821C19.451 1.17508 19.451 1.49167 19.6463 1.68693L22.1261 4.16671H11.9998C5.46447 4.16671 0.166504 9.46467 0.166504 16C0.166504 22.5354 5.46447 27.8334 11.9998 27.8334C18.5352 27.8334 23.8332 22.5354 23.8332 16C23.8332 15.7239 23.6093 15.5 23.3332 15.5C23.057 15.5 22.8332 15.7239 22.8332 16C22.8332 21.9831 17.9829 26.8334 11.9998 26.8334C6.01675 26.8334 1.1665 21.9831 1.1665 16C1.1665 10.017 6.01675 5.16671 11.9998 5.16671H22.1261L19.6463 7.64649C19.451 7.84175 19.451 8.15833 19.6463 8.35359C19.8415 8.54886 20.1581 8.54886 20.3534 8.35359L23.6867 5.02026C23.882 4.825 23.882 4.50842 23.6867 4.31315L20.3534 0.979821C20.1581 0.784558 19.8415 0.784558 19.6463 0.979821Z'
    />
    <text x='50%' y='58%' fontSize={12} dominantBaseline='middle' textAnchor='middle'>
      {children}
    </text>
  </svg>
);

export default ForwardLargeIcon;
